export enum BerthFItInformationParams {
  PortContacts = 'OtherContacts',
  SpecialNotes = 'SpecialNotes',
  VesselHandled = 'VesselHandled',
  ShipHandled = 'ShipHandled',
  VesselRestrictionsApproaches = 'VesselRestrictionsAtApproaches',
  LoadingRate = 'LoadingRate',
  CargoType = 'CargoType',
}
